import * as React from 'react';
import { CLASS_BOARD_DETAILS } from '../../../../constants';
import './_Chats.scss';
import { IChatsProps } from './types';
import { Checkbox, Radio } from 'kui';
import { CHATS_TITLE, CHATS_TYPE_CHECKBOXES, CHATS_TYPE_RADIO } from './constants';
import { EChatDashboardSettingsScope } from '../../../../../../../../types/rest/IRestChatDashboardSettings';
import { updateScopeList } from '../../../Notifications/components/helpers/updateScopeList';
import { AnalyzeRender } from '../../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`Chats`) : null;

export function Chats ({
    boardId,
    scopes,
    onChange,
    onScopeClick,
    isDisabled,
    isReadOnly
 }: IChatsProps) {
    if (analyzeRender) analyzeRender.call(`Chats ${boardId}`);

    const className = CLASS_BOARD_DETAILS + '__chats';
    const classHeader = CLASS_BOARD_DETAILS  + '__chats-header';
    const classLevel = CLASS_BOARD_DETAILS  + '__checkbox-level';
    const classText = CLASS_BOARD_DETAILS + '__chats-text';

    const [index, setIndex] = React.useState(null);
    const [scopeList, setScopeList] = React.useState(scopes);

    const radioValues = CHATS_TYPE_RADIO.map((item) => item.value);

    const getIndex = () => {
        for (let i = 0; i < radioValues.length; i++) {
            let index;
            if (scopes.includes(radioValues[i])) {
                index = i
                return index
            }
        }
    }

    const onScopeChangeHandler = (scope: EChatDashboardSettingsScope) => {
        onScopeClick(scope, !scopeList.includes(scope));
        let _scopeList: EChatDashboardSettingsScope[];
        if (radioValues.includes(scope)) {
            _scopeList = scopeList.filter((item) => !radioValues.includes(item))
            _scopeList.push(scope)
        } else {
            _scopeList = updateScopeList<EChatDashboardSettingsScope>(scope, scopeList);
        }
        if (scope === EChatDashboardSettingsScope.SETTING_ALL) {
            _scopeList = [EChatDashboardSettingsScope.SETTING_ALL]
        }
        onChange(_scopeList)
    }

    React.useEffect(() => {
        setScopeList(scopes);
        setIndex(getIndex())
    }, [scopes]);

    return (
        <div className={classText}>
            <div
                className={classHeader}
            >
                {CHATS_TITLE}
            </div>
            <div>
                <Radio
                    className={className + '--radio'}
                    active={index}
                    direction={'left'}
                    onChange={ e => onScopeChangeHandler(CHATS_TYPE_RADIO[e.index].value)}
                >
                    {
                        CHATS_TYPE_RADIO.map(item => {
                            const {title, value} = item
                            return (
                                <span
                                    className={`${className}-item ${className}-item--${value} ${isDisabled || isReadOnly ? 'disabled' : ''}`}
                                    key={value}
                                >
                                {title}
                            </span>
                            )
                        })
                    }
                </Radio>
            </div>
            <div
                className={classLevel}
            >
                <div>
                    {CHATS_TYPE_CHECKBOXES.map((cb) =>
                        <Checkbox
                            key={cb.value}
                            direction={'left'}
                            checked={scopeList.includes(cb.value as EChatDashboardSettingsScope)}
                            disabled={isDisabled || isReadOnly || scopeList.includes(EChatDashboardSettingsScope.SETTING_ALL)}
                            value={cb.value as EChatDashboardSettingsScope}
                            onChange={(e) => onScopeChangeHandler(cb.value as EChatDashboardSettingsScope)}
                        >
                            {cb.title}
                        </Checkbox>)
                    }
                </div>
            </div>
        </div>
    );
};
